import React from 'react';
import {render} from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import routes from './routes';
import configureStore from './store/configureStore';

//import bootstrap from './store/bootstrap.min';
//import easyResponsiveTabs from './store/easyResponsiveTabs';
/*import configureStore from './store/configureStore';
import configureStore from './store/configureStore';
import configureStore from './store/configureStore';
import configureStore from './store/configureStore';*/

import './styles/bootstrap.min.css';
import './styles/style.css';
import './styles/button.css';
import './styles/footer.css';
import './styles/form.css';
import './styles/header.css';
import './styles/login.css';
import './styles/materialdesignicons.min.css';
import '../node_modules/@trendmicro/react-toggle-switch/dist/react-toggle-switch.css';
import './styles/sidebar.css';
import './styles/typography.css';
import './styles/vendor-profile.css';
import './styles/dropdown.css';
import './styles/dashboard.css';
import './styles/vendordetail.css';
import './styles/my-request.css';
import './styles/notification.css';
import './styles/overview.css';
import './styles/mobileNotification.css';
import './styles/headerNotify.css';
import './styles/open-jobs.css';
import './styles/results.css';
import './styles/inbox.css';
import './styles/status-list.css';
import '../node_modules/react-input-range/lib/css/index.css';
import './styles/profile-creation.css';
import '../node_modules/rc-time-picker/assets/index.css';
import './styles/jobslider.css';
import './styles/manage-profile.css';
import '../node_modules/react-custom-scroll/dist/customScroll.css';
import './styles/scrollbar.css';
import './styles/pageNotFound.css';
import './styles/user-accounts.css';
import '../node_modules/react-image-gallery/styles/css/image-gallery.css';
import '../node_modules/react-image-gallery/styles/css/image-gallery-no-icon.css';
import '../node_modules/react-phone-number-input/rrui.css';
import '../node_modules/react-phone-number-input/style.css';
import './styles/modal.css';
import './styles/job-history.css';
import './styles/toast.css';
import './styles/empty-state.css';
import '../node_modules/react-datepicker/dist/react-datepicker.css';
import './styles/job-details.css';
import './styles/manage-user.css';
import './styles/vendor-mobile.css';
import './styles/job-detail-responsive.css';
import './styles/manage-services.css';
import './styles/custom-panel.css';
import './styles/manage-service-mobile.css';
import './styles/details-holder.css';
import './styles/terms.css';
import './styles/walkthrough.css';
import './styles/onboarding.css';
import './styles/driveremergency.css';
import './styles/business-style.css';
import './styles/review-rating.css';
import './styles/faq.css';
import './styles/contact-us.css';
import './styles/mobile-search.css';
import './styles/lightBox.css';

//import './styles/owl.carousel.css';
import './styles/flexslider.css';



import '../node_modules/slick-carousel/slick/slick-theme.css';
import '../node_modules/slick-carousel/slick/slick.css';
import 'intro.js/introjs.css';

//import '../node_modules/owl.carousel/dist/assets/owl.carousel.css';
//import $ from 'jquery';
//import '../node_modules/owl.carousel/dist/owl.carousel.min.js';
import {gtmId} from "./constants/staticData";
import TagManager from 'react-gtm-module';
import '../node_modules/react-modal-video/scss/modal-video.scss';
import './styles/floating-menu.css';



const tagManagerArgs = {
  gtmId: gtmId,
  dataLayerName: 'PageDataLayer'
}

TagManager.initialize(tagManagerArgs);


export const store = configureStore();

const history = syncHistoryWithStore(browserHistory, store);
console.log('called render in index.js');
render(
  <Provider store={store}>
    <Router history={history} routes={routes} />
  </Provider>, document.getElementById('app')
);




// WEBPACK FOOTER //
// ./src/index.js